<div class="mijn-login" mijn-analyse>
    <router-outlet></router-outlet>
</div>
